/**
 * Thai.
 *
 * Fully translated, unlike the Filipino languages: Thai readers expect Thai,
 * and the loanwords that do stay ("followers", "likes") are the ones Thai
 * social media itself uses. Written with ครับ/ค่ะ omitted throughout, which
 * is the neutral register for interface copy — polite particles in buttons
 * read as chatty rather than respectful.
 */
export default {
  nav: {
    home: 'หน้าแรก',
    services: 'บริการ',
    faq: 'คำถามที่พบบ่อย',
    help: 'ช่วยเหลือ',
    signIn: 'เข้าสู่ระบบ',
    getStarted: 'เริ่มต้น',
    openPanel: 'เปิดแผงควบคุม',
    language: 'ภาษา',
    currency: 'สกุลเงิน',
  },

  common: {
    perThousand: 'ต่อ 1,000',
    from: 'เริ่มต้น {amount} ต่อ 1,000',
    noSubscription: 'ไม่มีค่าสมาชิกรายเดือน',
    neverPassword: 'ไม่ขอรหัสผ่านของคุณ',
    cancel: 'ยกเลิก',
    done: 'เสร็จสิ้น',
    total: 'ยอดรวม',
    rate: 'ราคา',
    range: 'ช่วง',
    starts: 'เริ่ม',
    refill: 'เติมคืน',
    quantity: 'จำนวน',
    lowest: 'ถูกที่สุด',
    services: 'บริการ',
    platforms: 'แพลตฟอร์ม',
    shownIn: 'แสดงเป็น {display} ตามอัตราวันนี้ · เรียกเก็บเป็น {platform}',
    chargedIn: 'เรียกเก็บเป็น {code}',
    cancelWhilePending: 'ขณะออร์เดอร์ยังรอดำเนินการ',
    notOffered: 'ไม่รองรับ',
    chargedAs: 'เรียกเก็บเป็น {amount}',
  },

  home: {
    refresh: {
      titleA: 'บริการโซเชียลมีเดีย',
      titleB: 'ราคาชัดเจน ติดตามออร์เดอร์ได้',
      lede: 'เลือกดูผู้ติดตาม ไลก์ และยอดวิวสำหรับ TikTok, Instagram และ YouTube ตรวจสอบราคา เวลาส่งโดยประมาณ และเงื่อนไขการเติมคืนก่อนสั่งซื้อ',
      eyebrowIdle: 'สำรวจบริการของเรา',
      demo: 'ตัวอย่างการติดตามออร์เดอร์',
      demoNote: 'ออร์เดอร์ตัวอย่าง · แอนิเมชันเร่งความเร็ว 60×',
      servicesKey: 'สำรวจแคตตาล็อก',
      servicesTitle: 'ค้นหาบริการที่เหมาะกับคุณ',
      servicesBody: 'เปรียบเทียบราคาปัจจุบันและเงื่อนไขบริการก่อนสร้างบัญชี เวลาเริ่มเป็นเพียงค่าประมาณ ไม่ใช่การรับประกันว่าจะเสร็จ',
      perThousand: 'ต่อ 1,000',
      minimum: 'จำนวนขั้นต่ำ',
      start: 'เวลาเริ่มโดยประมาณ',
      notListed: 'ไม่ระบุ',
      refill: 'การรับประกันเติมคืน',
      days: '{count} วัน',
      seeTerms: 'ดูเงื่อนไขบริการ',
      details: 'ดูรายละเอียดบริการ',
      loading: 'กำลังโหลดบริการปัจจุบัน…',
      empty: 'ขณะนี้ยังไม่มีบริการให้ดูตัวอย่าง โปรดดูแคตตาล็อกเพื่อตรวจสอบบริการที่มี',
      currencyNote: 'ราคาที่แปลงสกุลเงินเป็นเพียงค่าประมาณ โปรดตรวจสอบสกุลเงินที่เรียกเก็บและยอดรวมสุดท้ายก่อนชำระเงิน',
      faqKey: 'ก่อนสั่งซื้อ',
      faqTitle: 'รู้ไว้ก่อนว่าจะเกิดอะไรขึ้น',
      moreAnswers: 'คำถามอื่น ๆ',
      closingTitle: 'ค้นหาบริการแรกของคุณ',
      closingBody: 'เปรียบเทียบราคาและเงื่อนไข แล้วเลือกจำนวนเมื่อคุณพร้อม',
      steps: {
        chooseTitle: 'เลือกบริการ',
        chooseBody: 'เลือกดูตามแพลตฟอร์ม แล้วเปรียบเทียบราคา จำนวนขั้นต่ำ และการรับประกันเติมคืน',
        reviewTitle: 'ตรวจสอบรายละเอียด',
        reviewBody: 'ใส่ลิงก์สาธารณะและจำนวน ตรวจสอบยอดรวม เวลาส่งโดยประมาณ และเงื่อนไขบริการก่อนยืนยัน',
        trackTitle: 'ติดตามออร์เดอร์',
        trackBody: 'ติดตามสถานะที่รายงานในบัญชีของคุณ ติดต่อฝ่ายสนับสนุนหากออร์เดอร์หยุดชะงักหรือผลลัพธ์ต้องได้รับการตรวจสอบ',
      },
      faq: {
        deliveryTitle: 'ใช้เวลาส่งนานแค่ไหน',
        deliveryBody: 'เวลาขึ้นอยู่กับบริการและจำนวน เวลาเริ่มโดยประมาณบอกว่าการส่งอาจเริ่มเมื่อใด ไม่ใช่เวลาที่จะเสร็จ อาจเกิดความล่าช้าได้ โปรดติดต่อฝ่ายสนับสนุนหากออร์เดอร์ของคุณเกินเวลาที่ประมาณไว้',
        dropsTitle: 'ผู้ติดตามหรือยอดอื่น ๆ ลดลงได้ไหม',
        dropsBody: 'ได้ ยอดอาจลดลงหลังส่งเสร็จ เฉพาะบริการที่มีการรับประกันเติมคืนเท่านั้นที่มีสิทธิ์ได้รับการเติมทดแทน ภายในระยะเวลาและเงื่อนไขที่ระบุ บริการที่ไม่มีการเติมคืนจะไม่รวมการทดแทน',
        refundsTitle: 'เงินคืนจะไปที่ไหน',
        refundsBody: 'เมื่อออร์เดอร์ได้รับการยืนยันว่ายกเลิกหรือส่งได้บางส่วน ยอดส่วนที่ยังไม่ได้ส่งซึ่งมีสิทธิ์คืนจะเข้ากระเป๋าเงิน PresenceRise ของคุณ ซึ่งเป็นเครดิตในบัญชี ไม่ใช่การคืนเงินเข้าบัตร ออร์เดอร์ที่กำลังดำเนินการจะไม่ได้รับเงินคืนอัตโนมัติเพียงเพราะล่าช้า',
        passwordTitle: 'ต้องให้รหัสผ่านโซเชียลมีเดียไหม',
        passwordBody: 'ไม่ต้อง ออร์เดอร์ใช้ลิงก์โปรไฟล์หรือโพสต์สาธารณะของคุณ ห้ามใส่รหัสผ่านหรือรหัสเข้าสู่ระบบในออร์เดอร์หรือข้อความถึงฝ่ายสนับสนุน',
        paymentsTitle: 'ชำระเงินได้ด้วยวิธีใดบ้าง',
        paymentsBody: 'วิธีที่ใช้ได้จะแสดงตอนชำระเงินหรือตอนเติมเงิน และอาจแตกต่างกันตามประเทศและสกุลเงิน โปรดตรวจสอบตัวเลือกและค่าธรรมเนียมก่อนชำระเงิน',
      },
    },
    eyebrow: '{count} บริการพร้อมใช้งานบน {platforms} แพลตฟอร์ม',
    eyebrowIdle: 'เปิดรับออร์เดอร์แล้ว',
    titleA: 'การเติบโตที่',
    titleB: 'คุณมองเห็นได้',
    lede: 'ผู้ติดตาม ไลก์ ยอดวิว และผู้สมัคร คิดราคาต่อหนึ่งพัน และส่งผ่านระบบที่คุณมองเห็นได้ ทุกออร์เดอร์ติดตามแบบเรียลไทม์ วัดผลหลังส่งเสร็จ และคืนเงินหรือเติมคืนให้เองเมื่อส่งไม่ครบ',
    ctaStart: 'เริ่มใช้ฟรี',
    ctaBrowse: 'ดูบริการทั้งหมด',
    ctaOrder: 'สั่งซื้อ',
    delivering: 'กำลังส่ง {count} รายการ',
    illustration: 'ภาพประกอบ เร่งความเร็ว 60 เท่า',
    figures: {
      services: 'บริการ',
      platforms: 'แพลตฟอร์ม',
      from: 'เริ่มต้น ต่อ 1,000',
      refill: 'มีระยะเวลาเติมคืน',
      remeasured: 'วันที่วัดผลออร์เดอร์ซ้ำ',
      tickets: 'ตั๋วที่ต้องเปิดเพื่อขอคืนเงิน',
    },
    life: {
      key: 'ชีวิตของหนึ่งออร์เดอร์',
      title: 'มีหกอย่างเกิดขึ้นกับทุกออร์เดอร์ และไม่มีอย่างไหนที่คุณต้องทำเอง',
      pricedTitle: 'คิดราคาที่เซิร์ฟเวอร์',
      pricedBody: 'จำนวนของคุณถูกคิดราคาด้วยโค้ดชุดเดียวกับที่ API ใช้ ยอดที่คุณยืนยันคือยอดที่ถูกเรียกเก็บ',
      chargedTitle: 'เรียกเก็บครั้งเดียว',
      chargedBody: 'ตัดยอดจากกระเป๋าเงินของคุณตอนสร้างออร์เดอร์ และจะไม่ตัดซ้ำสำหรับออร์เดอร์นั้นอีก',
      sentTitle: 'ส่งต่อและติดตาม',
      sentBody: 'ส่งไปยังผู้ให้บริการที่ส่งงานอยู่ได้ดีที่สุดสำหรับบริการนั้น แล้วติดตามจนกว่าจะเสร็จ',
      deliveringTitle: 'กำลังส่ง',
      deliveringBody:
        'ดูได้บนกราฟ Climb ว่าคุณเริ่มที่เท่าไร ตอนนี้อยู่ที่เท่าไร และจะไปถึงไหนด้วยความเร็วปัจจุบัน',
      measuredTitle: 'วัดผลที่ 1, 7 และ 30 วัน',
      measuredBody: 'อ่านยอดที่ส่งแล้วซ้ำและเทียบกับตอนส่งเสร็จ แล้วเผยแพร่เปอร์เซ็นต์ที่ยังอยู่',
      settledTitle: 'เติมคืนหรือคืนเงินให้เอง',
      settledBody:
        'ยอดที่หายไปในช่วงเติมคืนจะยื่นขอเติมคืนอัตโนมัติ ส่วนออร์เดอร์ที่ส่งไม่ครบจะคืนส่วนต่างเข้ากระเป๋าเงินของคุณ',
    },
    kept: {
      key: 'ทำไมเราถึงไม่ใช่ที่ถูกที่สุด',
      title: 'ผู้ติดตามที่ถูกที่สุดคือคนที่อยู่ต่อ',
      body: 'ราคาที่ถูกกว่าแต่หายไปหนึ่งในสาม แพงกว่าเมื่อคิดต่อผู้ติดตามที่เหลืออยู่จริง เทียบกับราคาที่สูงกว่าแต่อยู่ครบ ทุกออร์เดอร์เลือกผู้ให้บริการจากราคาต่อหน่วยที่เหลืออยู่ ไม่ใช่ราคาป้าย และตัวเลขการคงอยู่ที่ใช้ตัดสินใจถูกพิมพ์ไว้บนบริการให้คุณตรวจสอบได้',
      link: 'คำตอบเต็ม อยู่ในคำถามที่พบบ่อย',
      sticker: 'ราคาป้าย',
      held: 'คงอยู่ที่ 30 วัน',
      effective: 'ต่อ 1,000 ที่เหลืออยู่',
      cheaper: 'รายการที่ถูกกว่า',
      ours: 'รายการที่เราเลือกส่ง',
      foot: 'ตัวเลขตัวอย่าง ตัวเลขจริงอยู่บนแต่ละบริการ พร้อมขนาดตัวอย่าง',
    },
    steps: {
      fundsTitle: 'เติมเงิน',
      fundsBody: 'บัตร หรือ GCash, Maya และ GrabPay ในฟิลิปปินส์ ไม่มีค่าสมาชิก',
      pickTitle: 'เลือกบริการ',
      pickBody: 'เลือกผลลัพธ์ที่ต้องการ วางลิงก์สาธารณะ แล้วดูยอดรวมที่แน่นอนก่อนยืนยัน',
      watchTitle: 'ดูมันไต่ขึ้น',
      watchBody: 'ติดตามการส่งแบบเรียลไทม์ ส่งไม่ครบคืนเงินเอง ยอดหายเติมคืนเอง',
    },
    cta: {
      title: 'พร้อมเมื่อคุณพร้อม',
      body: 'ไม่มีค่าสมาชิก ไม่มียอดขั้นต่ำ และไม่เคยขอรหัสผ่านของคุณ',
      account: 'สร้างบัญชี',
    },
  },

  services: {
    key: 'บริการ',
    titleA: 'ทุกบริการ',
    titleB: 'ทุกราคา',
    lede: 'แกนราคาหนึ่งเส้นต่อหนึ่งผลลัพธ์ การกระจายของเครื่องหมายจึงคือภาพตลาดจริง ทุกราคาคิดต่อ 1,000 หน่วย และไม่มีค่าใช้จ่ายเพิ่มตอนชำระเงิน คลิกที่แถวเพื่อคิดราคาตามจำนวนจริง',
    quality: 'คุณภาพ',
    region: 'ภูมิภาค',
    anyQuality: 'ทุกคุณภาพ',
    anyRegion: 'ทุกภูมิภาค',
    allPlatforms: 'ทุกแพลตฟอร์ม',
    search: 'ค้นหาบริการ',
    refillOnly: 'เฉพาะที่มีเติมคืน',
    sort: 'เรียงตาม',
    sortPrice: 'ราคา',
    sortRetention: 'การคงอยู่',
    sortName: 'ชื่อ',
    empty: 'ไม่พบบริการที่ตรงกัน',
    emptyBody: 'ลองคำค้นอื่น หรือล้างตัวกรอง',
    showEverything: 'แสดงทั้งหมด',
    priceIt: 'คิดราคา',
    priceEmpty:
      'คลิกแถวใดก็ได้ แล้วราคาสำหรับจำนวนจริงจะปรากฏที่นี่ — เป็นยอดเดียวกับที่หน้าสั่งซื้อจะเรียกเก็บ',
    order: 'สั่งซื้อรายการนี้',
    orderGuest: 'สร้างบัญชีเพื่อสั่งซื้อ',
    includes: 'ราคานี้รวมอะไรบ้าง',
    terms: {
      perThousandTitle: 'ราคาคิดต่อ 1,000 หน่วย',
      perThousandBody:
        'ทุกบริการเสนอราคาแบบเดียวกัน จึงเทียบกันได้ตรง ๆ ราคา $1.23 ได้ 1,000 หน่วย ส่วน 500 หน่วยคิดครึ่งเดียว',
      totalTitle: 'คำนวณยอดรวมก่อนคุณยืนยัน',
      totalBody:
        'จำนวนของคุณถูกคิดราคาบนเซิร์ฟเวอร์ของเราและแสดงเต็มจำนวน ยอดที่คุณยืนยันคือยอดที่ถูกเรียกเก็บ ไม่มีอะไรเพิ่มตอนชำระเงิน',
      balanceTitle: 'คุณเติมยอดคงเหลือ ไม่ใช่สมัครสมาชิก',
      balanceBody: 'เติมเงินเมื่อต้องการและใช้จ่ายจากยอดนั้น ไม่มีการตัดเงินซ้ำ ไม่มียอดขั้นต่ำรายเดือน',
      refundTitle: 'ออร์เดอร์ที่ส่งไม่ครบคืนเงินอัตโนมัติ',
      refundBody:
        'ถ้าส่งได้ไม่ครบ ส่วนที่ยังไม่ได้ส่งจะกลับเข้ายอดคงเหลือของคุณเอง คุณไม่ต้องสังเกตหรือเปิดตั๋วแจ้ง',
      refillTitle: 'หลายบริการมีระยะเวลาเติมคืน',
      refillBody:
        'บริการที่มีเติมคืนจะแสดงระยะเวลาไว้บนแถว และเราจะยื่นขอเติมคืนให้เมื่อการตรวจวัดพบว่ายอดลดลง',
    },
  },

  auth: {
    signInKey: 'เข้าสู่ระบบ',
    signInTitle: 'ยินดีต้อนรับกลับมา',
    signInLede: 'ออร์เดอร์ ยอดคงเหลือ และทุกอย่างที่ยังส่งอยู่ ยังอยู่ที่เดิม',
    identifier: 'ชื่อผู้ใช้หรืออีเมล',
    password: 'รหัสผ่าน',
    passwordPlaceholder: 'รหัสผ่านของคุณ',
    passkey: 'เข้าสู่ระบบด้วยพาสคีย์',
    or: 'หรือ',
    forgot: 'ลืมรหัสผ่าน?',
    remember: 'ให้เข้าสู่ระบบค้างไว้ 30 วัน',
    newHere: 'เพิ่งเข้ามาใหม่?',
    createAccount: 'สร้างบัญชี',
    show: 'แสดง',
    hide: 'ซ่อน',

    registerKey: 'สร้างบัญชี',
    registerTitle: 'สั่งซื้อได้ในไม่ถึงหนึ่งนาที',
    registerLede: 'ใช้แค่ชื่อผู้ใช้กับรหัสผ่าน',
    registerCarries: 'บริการที่คุณเลือกไว้รออยู่อีกฝั่งแล้ว',
    registerClosed: 'ปิดรับสมัครชั่วคราว กรุณากลับมาใหม่ภายหลัง',
    username: 'ชื่อผู้ใช้',
    usernameHint: 'ตัวอักษร ตัวเลข จุด ขีดกลาง และขีดล่าง',
    newPassword: 'รหัสผ่าน',
    newPasswordPlaceholder: 'อย่างน้อย 10 ตัวอักษร',
    noEmailTitle: 'ไม่ต้องใช้อีเมลก็เริ่มได้',
    noEmailBody:
      'คุณเพิ่มอีเมลตอนชำระเงินได้ ระหว่างที่ยังไม่มี เราจะกู้บัญชีให้ไม่ได้ บัญชีที่ไม่มีอีเมลจึงถูกลบหลัง 5 วัน การเพิ่มอีเมลจะเก็บบัญชีไว้ — และสิ่งที่คุณจ่ายเงินไปแล้วจะไม่ถูกลบอัตโนมัติ',
    agreeA: 'ฉันยอมรับ',
    terms: 'ข้อกำหนดการให้บริการ',
    agreeB: 'และ',
    privacy: 'นโยบายความเป็นส่วนตัว',
    haveAccount: 'มีบัญชีอยู่แล้ว?',

    caseKey: 'การสั่งซื้อที่นี่ทำงานอย่างไร',
    caseTitle: 'การเติบโตที่คุณมองเห็นได้',
    caseNoEmailTitle: 'ไม่ต้องใช้อีเมลก็เริ่มได้',
    caseNoEmailBody: 'ใช้แค่ชื่อผู้ใช้กับรหัสผ่าน เพิ่มอีเมลตอนชำระเงินได้ ซึ่งใช้เป็นใบเสร็จ ไม่ใช่ด่านกั้น',
    casePricedTitle: 'คิดราคาก่อนคุณยืนยัน',
    casePricedBody: 'ทุกยอดรวมคำนวณบนเซิร์ฟเวอร์ของเราและแสดงเต็มจำนวน ยอดที่คุณยืนยันคือยอดที่ถูกเรียกเก็บ',
    caseSettledTitle: 'คืนเงินหรือเติมคืนให้เอง',
    caseSettledBody:
      'ส่งไม่ครบจะคืนเข้ากระเป๋าเงินโดยไม่ต้องเปิดตั๋ว ยอดที่หายในช่วงเติมคืนเราจะยื่นขอเติมคืนให้',
    backToSite: 'กลับไปหน้าเว็บ',
  },

  upsell: {
    title: 'ทำให้ดูเป็นธรรมชาติ',
    sameLink: 'ทุกอย่างในนี้จะส่งไปยังลิงก์เดียวกับออร์เดอร์ด้านบน',
    why: {
      likesForPlays: 'ยอดเล่นที่มาพร้อมไลก์คือภาพของเพลงที่กำลังมาแรง',
      likesForViews:
        'วิดีโอที่มียอดวิวแต่ไม่มีไลก์ดูเหมือนซื้อมา ไลก์สักไม่กี่เปอร์เซ็นต์ของยอดวิวจะดูเหมือนมีคนดูจริง',
      viewsForLikes:
        'ไลก์โดยไม่มีวิวคือจุดที่แปลก ไม่มีใครกดไลก์วิดีโอที่ยังไม่ได้ดู และกับวิดีโอใหม่ สัดส่วนนี้จะเห็นชัด',
      subsForViews: 'ในผู้ชมทุกพันคนจะมีไม่กี่คนที่ติดตาม วิวที่ไม่พาใครมาเลยดูเหมือนตัวเลข ไม่ใช่ผู้ชม',
      likesForFollowers:
        'ผู้ติดตามใหม่ที่ไม่กดไลก์อะไรเลยจะสังเกตได้ ไลก์เล็กน้อยบนโพสต์ล่าสุดทำให้การเติบโตดูเป็นคนจริง',
      viewsForSubs: 'ผู้สมัครมาจากวิดีโอที่ถูกดู วิวบนวิดีโอล่าสุดทำให้ผู้สมัครใหม่สมเหตุสมผล',
      likesForSubs: 'คนที่กดติดตามมักกดไลก์อะไรบางอย่างมาก่อน',
      followersForPlays: 'ยอดเล่นจากผู้ฟังที่ติดตามต่อคือภาพของเพลงที่กำลังมาแรง',
      likesForComments: 'คอมเมนต์มากกว่าไลก์เป็นสัญญาณผิดปกติ คนที่คอมเมนต์ส่วนใหญ่ก็กดไลก์ด้วย',
      likesForShares: 'แชร์โดยไม่มีไลก์แทบไม่เกิดขึ้น ไลก์ทำให้แชร์น่าเชื่อ',
      viewsForReactions: 'รีแอคชันบนโพสต์ที่มีคนเห็นน้อยจะโดดออกมา มีวิวก่อน รีแอคชันจึงดูจริง',
    },
  },

  guest: {
    orderWithout: 'สั่งซื้อโดยไม่ต้องมีบัญชี',
    orderTitle: 'สั่งซื้อแบบผู้เยี่ยมชม',
    orderLede:
      'ชำระเงิน แล้วออร์เดอร์จะถูกวาง อีเมลใบเสร็จมีลิงก์คลิกเดียวสำหรับสร้างบัญชีที่มีออร์เดอร์นี้อยู่แล้ว',
    email: 'อีเมลสำหรับใบเสร็จ',
    emailHint: 'รายละเอียดออร์เดอร์และลิงก์สร้างบัญชีจะส่งมาที่นี่ ไม่มีอย่างอื่น',
    linkLabel: 'ลิงก์หรือชื่อผู้ใช้',
    linkHint: 'ลิงก์ไปยังโปรไฟล์หรือโพสต์สาธารณะ บัญชีส่วนตัวไม่สามารถส่งให้ได้',
    payWith: 'ชำระด้วย',
    noMethods: 'ระบบชำระเงินกำลังตั้งค่า เข้าสู่ระบบเพื่อสั่งซื้อจากยอดคงเหลือ',
    pay: 'ชำระ {amount}',
    methods: {
      xenditPhLabel: 'GCash, Maya และโอนธนาคาร',
      xenditPh: 'GCash, Maya, GrabPay และโอนธนาคาร',
      xenditId: 'OVO, DANA, โอนธนาคาร และร้านค้าปลีก',
      local: 'เรียกเก็บเป็น {currency} · ไม่มีการแปลงสกุลเงิน',
    },
    feeNote: 'รวมค่าธรรมเนียม {method} {fee} เพื่อให้ออร์เดอร์ชำระครบ',
    minimumNote: 'ขั้นต่ำของวิธีนี้คือ {amount} ส่วนต่างจะเก็บเป็นยอดคงเหลือในบัญชีของคุณ',
    basket: 'ตะกร้า',
    haveAccount: 'มีบัญชีอยู่แล้ว?',
    status: {
      eyebrow: 'ออร์เดอร์ของคุณ',
      waitingTitle: 'กำลังยืนยันการชำระเงิน',
      waitingLede: 'ผู้ให้บริการชำระเงินกำลังแจ้งเราว่าสำเร็จแล้ว ปกติใช้เวลาไม่กี่วินาที หน้านี้จะอัปเดตเอง',
      placedTitle: 'ออร์เดอร์ของคุณถูกวางแล้ว',
      placedLede: 'การส่งจะเริ่มเอง ใบเสร็จกำลังไปที่อีเมลของคุณ พร้อมลิงก์ที่ทำให้นี่เป็นบัญชีของคุณ',
      failedTitle: 'การชำระเงินไม่สำเร็จ',
      failedLede: 'ไม่มีการเรียกเก็บและไม่มีการวางออร์เดอร์ คุณเริ่มใหม่ได้ทุกเมื่อ',
      canceledLede: 'การชำระเงินถูกยกเลิกก่อนเสร็จ ไม่มีการเรียกเก็บ',
      reference: 'เลขอ้างอิง',
      paid: 'ชำระแล้ว',
      email: 'ใบเสร็จส่งไปที่',
      polling: 'รอผู้ให้บริการ…',
      failedItems: '{count} รายการวางไม่ได้ เงินถูกเก็บเป็นยอดคงเหลือในบัญชีของคุณ อีเมลจะอธิบาย',
      nextKey: 'ขั้นต่อไป',
      nextBody:
        'เปิดอีเมลแล้วคลิก "Create my account" เลือกชื่อผู้ใช้กับรหัสผ่าน แล้วออร์เดอร์เหล่านี้จะอยู่บนหน้าจอ พร้อมการส่งแบบสด เติมคืนและคืนเงินที่จัดการให้ ลิงก์ใช้ได้ 30 วัน',
      help: 'ศูนย์ช่วยเหลือ',
      tryAgain: 'ลองอีกครั้ง',
      notFound: 'เราไม่พบการชำระเงินนั้น',
    },
    claim: {
      key: 'สร้างบัญชีของคุณ',
      loading: 'สักครู่…',
      title: 'เลือกชื่อผู้ใช้และรหัสผ่าน',
      lede: 'แค่นั้น ออร์เดอร์ที่ชำระแล้ว {count} รายการอยู่ในบัญชีนี้แล้ว',
      emailConfirmed: '{email} ยืนยันแล้ว — คุณคลิกลิงก์ที่เราส่งไป',
      submit: 'สร้างบัญชีและดูออร์เดอร์',
      invalidTitle: 'ลิงก์นี้หมดอายุแล้ว',
      invalidLede:
        'ลิงก์รับบัญชีใช้ได้ 30 วัน ถ้าสร้างบัญชีแล้วให้เข้าสู่ระบบ ถ้ายังไม่ได้ ติดต่อศูนย์ช่วยเหลือพร้อมแจ้งหมายเลขออร์เดอร์',
    },
  },

  footer: {
    tagline: 'การเติบโตที่คุณมองเห็นได้',
    blurb:
      'เลือกดูบริการโซเชียลมีเดียที่มีราคาชัดเจนและติดตามออร์เดอร์ได้ เวลาส่งโดยประมาณ การรับประกันเติมคืน และสิทธิ์การคืนเงินขึ้นอยู่กับแต่ละบริการ',
    startKey: 'เริ่มได้ในไม่ถึงหนึ่งนาที',
    createAccount: 'สร้างบัญชี',
    getHelp: 'ขอความช่วยเหลือ',
    startNote: 'ใช้แค่ชื่อผู้ใช้กับรหัสผ่าน การช่วยเหลือทำผ่านตั๋ว ซึ่งผูกกับบัญชีและออร์เดอร์ของคุณอยู่แล้ว',
    product: 'ผลิตภัณฑ์',
    help: 'ช่วยเหลือ',
    legal: 'ข้อกฎหมาย',
    platforms: 'แพลตฟอร์ม',
    pricing: 'ราคา',
    signIn: 'เข้าสู่ระบบ',
    helpCentre: 'ศูนย์ช่วยเหลือ',
    terms: 'ข้อกำหนดการให้บริการ',
    privacy: 'นโยบายความเป็นส่วนตัว',
    rights: '© {year} {site} สงวนลิขสิทธิ์',
    mono: 'ราคาต่อ 1,000 · ตรวจสอบยอดรวมก่อนชำระเงิน',
    notAffiliated: 'ไม่มีส่วนเกี่ยวข้องกับแพลตฟอร์มโซเชียลมีเดียใด ๆ',
    top: 'ขึ้นบน',
  },

  faq: {
    eyebrow: 'ศูนย์ช่วยเหลือ',
    titleA: 'สิ่งที่ควรถาม',
    titleEm: 'ก่อน',
    titleB: 'จ่ายเงิน',
    lede: 'รวมถึงคำถามที่คำตอบไม่น่าฟัง ถ้าไม่มีในนี้ ถามได้เลย รายการนี้เติบโตจากสิ่งที่คนถามจริง',
    searchPlaceholder: 'ค้นหาจาก {count} คำถาม',
    searchLabel: 'ค้นหาคำถาม',
    clearSearch: 'ล้างการค้นหา',
    try: 'ลอง',
    suggestions: 'คืนเงิน, รหัสผ่าน, GCash, ยกเลิก, ลดลง',
    topics: 'หัวข้อ',
    ofTotal: 'จาก {total}',
    inTopic: 'ใน {topic}',
    matching: 'ที่ตรงกับ “{query}”',
    showAll: 'แสดงทั้งหมด',
    emptyTitle: 'ไม่มีอะไรตรงกับ “{query}”',
    emptyText: 'ลองใช้คำอื่น หรือถามโดยตรง คำถามที่ยังไม่มีคำตอบคือสิ่งที่ทำให้รายการนี้ยาวขึ้น',
    previous: 'ก่อนหน้า',
    next: 'ถัดไป',
    stillUnsure: 'ยังไม่แน่ใจ? เปิดตั๋ว',
    contactKey: 'ยังติดอยู่?',
    contactTitle: 'ถามคนที่ดูแลระบบนี้',
    contactText:
      'การช่วยเหลือทำผ่านตั๋วในแผงควบคุม ไม่ใช่กล่องจดหมาย ตั๋วไปถึงคนกลุ่มเดียวกัน และมาพร้อมบัญชีและออร์เดอร์ของคุณอยู่แล้ว จึงไม่มีใครต้องขอหมายเลขออร์เดอร์จากคุณ',
    contactNote: 'ยังไม่มีบัญชี? สร้างได้ด้วยชื่อผู้ใช้กับรหัสผ่าน ใช้เวลาประมาณสามสิบวินาที',
    openTicket: 'เปิดตั๋ว',
    createAccount: 'สร้างบัญชี',
    groups: {
      quality: { label: 'คุณภาพและการลดลง', blurb: 'อยู่ทนไหม และเราทำอะไรเมื่อไม่ทน' },
      orders: { label: 'ออร์เดอร์', blurb: 'ความเร็ว ลิงก์ ส่งไม่ครบ และการยกเลิก' },
      money: { label: 'การชำระเงิน', blurb: 'การจ่าย ราคาตามภูมิภาค และ wallet ของคุณ' },
      account: {
        label: 'บัญชีและความปลอดภัย',
        blurb: 'รหัสผ่าน ความเสี่ยงจากแพลตฟอร์ม การสมัคร ข้อมูลของคุณ',
      },
    },
    q: {
      retention: {
        q: 'ผู้ติดตามอยู่ทนไหม หรือหายไป?',
        a1: 'มีลดลงบ้าง ใครบอกว่าไม่มีคือกำลังขายอะไรบางอย่างให้คุณ บัญชีถูกลบ คนเลิกติดตาม และแพลตฟอร์มกวาดล้าง engagement ปลอมเป็นระลอก',
        a2: 'สิ่งที่ต่างคือเราวัดมัน ทุกออร์เดอร์ที่เสร็จจะถูกตรวจซ้ำที่ 1, 7 และ 30 วัน แล้วเทียบยอดที่ส่งกับยอดตอนเสร็จ เมื่อมีข้อมูลพอ เปอร์เซ็นต์ที่อยู่ทนจะแสดงบนฟอร์มสั่งซื้อข้างราคา พร้อมจำนวนออร์เดอร์ที่ใช้วัด',
        a3: 'เราแสดงตัวเลขนั้นแม้จะแย่ บริการที่อยู่ทน 78% ก็แสดงว่า 78%',
      },
      refill: {
        q: 'ถ้าออร์เดอร์ลดลงจะเกิดอะไรขึ้น?',
        a1: 'สำหรับบริการที่มีการรับประกันเติมคืน เราเป็นคนยื่นเติมคืนเอง คุณไม่ต้องสังเกต และไม่ต้องขอ การวัดเดียวกันที่ให้ตัวเลขการอยู่ทนคือสิ่งที่สั่งให้เติมคืน',
        a2: 'นี่คือคำร้องเรียนที่พบบ่อยที่สุดในวงการนี้: ขายการรับประกันเติมคืน แล้วเงียบหายเมื่อมีคนพยายามใช้ การตัดขั้นตอนขอออกไปคือประเด็นสำคัญ',
      },
      qualityVsPrice: {
        q: 'ทำไมคุณไม่ใช่เจ้าที่ถูกที่สุด?',
        a1: 'เพราะที่ถูกที่สุดมักไม่ใช่ที่ถูกที่สุดจริง ผู้ติดตามหนึ่งพันคนในราคาถูกกว่าแต่หายไปหนึ่งในสาม แพงกว่าต่อผู้ติดตามที่เหลืออยู่จริง เมื่อเทียบกับเจ้าที่แพงกว่าแต่อยู่ทน',
        a2: 'เราส่งทุกออร์เดอร์โดยดูราคาต่อผู้ติดตามที่อยู่รอด ไม่ใช่ราคาป้าย และตรรกะเดียวกันกำหนดสิ่งที่เราคิดเงิน บางครั้งเราก็ถูกที่สุด เมื่อไม่ใช่ ส่วนต่างคือการซื้อการส่งที่อยู่ทน',
      },
      speed: {
        q: 'ออร์เดอร์เริ่มเร็วแค่ไหน?',
        a1: 'บริการส่วนใหญ่เริ่มภายในไม่กี่นาที แต่ละบริการแสดงเวลาเริ่มและความเร็วปกติของตัวเองบนฟอร์มสั่งซื้อ ซึ่งมาจากสิ่งที่บริการนั้นทำจริง ไม่ใช่คำสัญญา',
        a2: 'ออร์เดอร์ที่ยังไม่ขยับจะเห็นได้ในรายการออร์เดอร์ของคุณพร้อมสถานะสด และคุณจะได้รับอีเมลเมื่อเสร็จ',
      },
      partial: {
        q: 'ถ้าออร์เดอร์ส่งได้แค่บางส่วนล่ะ?',
        a1: 'ส่วนที่ไม่ได้ส่งจะคืนเงินให้อัตโนมัติในอัตราที่คุณจ่าย และเงินกลับเข้า wallet โดยคุณไม่ต้องขอ ออร์เดอร์ที่ล้มเหลวทั้งหมดก็คืนเงินเต็มจำนวนแบบเดียวกัน',
        a2: 'การคืนเงินคำนวณจากออร์เดอร์และบันทึกลง ledger โดยระบบ ไม่ใช่โดยคนที่ตัดสินว่าจะให้หรือไม่',
      },
      cancel: {
        q: 'ยกเลิกออร์เดอร์ได้ไหม?',
        a1: 'สำหรับบริการที่รองรับการยกเลิก ได้ ตัวเลือกจะปรากฏบนออร์เดอร์นั้นเอง หลายบริการยกเลิกไม่ได้เมื่อเริ่มส่งแล้ว และฟอร์มสั่งซื้อจะบอกว่าบริการไหนเป็นแบบไหนก่อนคุณซื้อ ไม่ใช่หลังจากนั้น',
      },
      link: {
        q: 'ควรให้ลิงก์แบบไหน?',
        a1: 'ตามที่บริการขอ: URL โปรไฟล์สำหรับผู้ติดตาม URL โพสต์สำหรับไลก์หรือยอดวิว บางครั้งแค่ชื่อผู้ใช้ ช่องกรอกจะบอกว่าต้องการแบบไหนและปฏิเสธรูปแบบที่ผิดก่อนคุณจ่าย ไม่ใช่ล้มเหลวทีหลัง',
        a2: 'บัญชีของคุณต้องเป็นสาธารณะระหว่างที่ออร์เดอร์ทำงาน บัญชีส่วนตัวรับการส่งไม่ได้ และการเติมคืนแก้เรื่องนี้ไม่ได้',
      },
      payment: {
        q: 'จ่ายเงินอย่างไร?',
        a1: 'บัตร และช่องทางชำระเงินท้องถิ่นในที่ที่เรารองรับ ในฟิลิปปินส์คือ GCash, Maya และ GrabPay',
        a2: 'เงินเข้ายอด wallet ก่อน แล้วออร์เดอร์หักจากตรงนั้น ออร์เดอร์จึงไม่ต้องรอการชำระเงินเคลียร์ และการคืนเงินเข้าทันทีแทนที่จะส่งกลับผ่านเครือข่ายบัตร',
      },
      regional: {
        q: 'ทำไมบางประเทศราคาถูกกว่า?',
        a1: 'เพราะราคาที่สมเหตุสมผลในลอนดอนไม่สมเหตุสมผลในมะนิลา ลูกค้าที่จ่ายจากประเทศที่รองรับจะได้รายการราคาท้องถิ่น',
        a2: 'ได้มาจากช่องทางชำระเงิน ไม่ใช่จากตำแหน่งที่คุณดูเหมือนจะเปิดเว็บอยู่: e-wallet ท้องถิ่น หรือบัตรที่ออกในประเทศนั้น ยุติธรรมกว่าการตรวจตำแหน่ง ซึ่งปลอมง่ายและจะกันคนที่ทำงานต่างประเทศแล้วซื้อให้ครอบครัวที่บ้านออกไปอย่างไม่เป็นธรรม',
      },
      refundWallet: {
        q: 'ถอนยอด wallet ได้ไหม?',
        a1: 'เงินใน wallet มีไว้สำหรับออร์เดอร์และถอนไม่ได้ เติมเท่าที่ตั้งใจจะใช้แทนการพักเงินไว้',
        a2: 'อะไรที่คืนเงินจากออร์เดอร์ที่ล้มเหลวหรือส่งไม่ครบจะกลับเข้า wallet และใช้กับอย่างอื่นได้',
      },
      password: {
        q: 'ต้องใช้รหัสผ่านของฉันไหม?',
        a1: 'ไม่ ไม่มีวัน เราขอแค่ลิงก์สาธารณะหรือชื่อผู้ใช้ และไม่มีอย่างอื่น',
        a2: 'บริการใดก็ตามที่ขอรหัสผ่านโซเชียลมีเดียของคุณ กำลังทำให้บัญชีคุณเสี่ยงหรือกำลังจะทำ ไม่มีเหตุผลที่ชอบธรรมสำหรับเรื่องนี้',
      },
      safe: {
        q: 'ปลอดภัยสำหรับบัญชีของฉันไหม?',
        a1: 'เราไม่แตะการเข้าสู่ระบบของคุณ และการส่งเกิดจากภายนอกบัญชีคุณ ข้อควรระวังตามตรงคือ การซื้อ engagement ขัดกับข้อกำหนดการให้บริการของแพลตฟอร์มใหญ่ทุกแห่ง และการบังคับใช้เป็นของพวกเขา ไม่ใช่ของเรา',
        a2: 'ในทางปฏิบัติ: สั่งในสัดส่วนที่เหมาะกับขนาดบัญชี หลีกเลี่ยงการสั่งของเดิมซ้ำ ๆ ในเวลาสั้น ๆ และมองว่าอะไรที่ดูฉับพลันคือความเสี่ยง การเติบโตช้า ๆ จะดูเหมือนการเติบโตช้า ๆ',
      },
      signup: {
        q: 'ทำไมสมัครได้โดยไม่ต้องใช้อีเมล?',
        a1: 'เพื่อให้คุณสั่งได้ในไม่ถึงหนึ่งนาที ชื่อผู้ใช้กับรหัสผ่านก็พอสำหรับการเริ่มต้น',
        a2: 'มีข้อแลกเปลี่ยนจริง และเราบอกล่วงหน้า: เมื่อไม่มีอีเมล เรากู้บัญชีหรือส่งใบเสร็จให้คุณไม่ได้ บัญชีที่ไม่มีอีเมลจึงถูกลบหลัง 5 วัน เพิ่มอีเมลเมื่อไหร่ก็ได้เพื่อเก็บบัญชีไว้ บัญชีที่มียอดเงิน ออร์เดอร์ หรือการชำระเงินจะไม่ถูกลบอัตโนมัติ แต่จะถูกส่งให้คนดูแทน',
      },
      privacy: {
        q: 'คุณทำอะไรกับข้อมูลของฉัน?',
        a1: 'เราเก็บเท่าที่จำเป็นในการทำออร์เดอร์ของคุณ และไม่เกินกว่านั้น เราไม่ขายข้อมูล และไม่โพสต์อะไรที่ไหน',
        a2: 'รายละเอียดทั้งหมดอยู่ในนโยบายความเป็นส่วนตัว ซึ่งเขียนให้อ่านได้ ไม่ใช่ให้ทนอ่าน',
      },
    },
  },

  help: {
    key: 'ศูนย์ช่วยเหลือ',
    title: 'ถามคนที่ดูแลระบบนี้',
    lede: 'ที่นี่ไม่มีกล่องจดหมาย ทุกอย่างกลายเป็นตั๋วในคิวเดียวที่ทีมงานของเราทำงานด้วย และคุณไม่ต้องมีอีเมลเพื่อรับความช่วยเหลือ หรือเพื่ออ่านคำตอบ',
    points: {
      findTitle: 'เข้าบัญชีไม่ได้? ค้นหาออร์เดอร์ของคุณ',
      findBody:
        'หมายเลขออร์เดอร์ ชื่อผู้ใช้ของบัญชี และสี่ตัวอักษรท้ายของรหัสอ้างอิงการชำระเงิน พิสูจน์ว่าเป็นของคุณ จากนั้นคุณจะเห็นว่าเกิดอะไรขึ้นกับมันบ้าง',
      autoTitle: 'คำตอบส่วนใหญ่ไม่ต้องใช้คน',
      autoBody:
        'ส่งไม่ครบคืนเงินเอง ลดลงเติมคืนเอง และหน้าออร์เดอร์บอกว่าเกิดอะไรขึ้น เมื่อต้องใช้คนจริง ๆ ส่งต่อได้จากหน้าจอเดียวกัน',
      repliesTitle: 'คำตอบอยู่บนตั๋ว',
      repliesBody:
        'เมื่อเข้าสู่ระบบ อยู่ใต้การช่วยเหลือ เมื่อไม่ได้เข้า อยู่บนหน้าที่เปิดด้วยหมายเลขและคีย์ ไม่มีอะไรส่งทางอีเมล และเราไม่เคยขอรหัสผ่านโซเชียลมีเดีย',
    },
    asideGuest: 'มีบัญชีและจำรหัสผ่านได้? {link} แล้วตั๋วจะถูกเก็บไว้ใต้การช่วยเหลือให้คุณ',
    asideGuestLink: 'เข้าสู่ระบบ',
    asideUser: 'ตั๋วของคุณอยู่ใต้ {link} พร้อมออร์เดอร์ของคุณข้าง ๆ',
    asideUserLink: 'การช่วยเหลือ',
    laneOrder: 'ค้นหาออร์เดอร์ของฉัน',
    laneTicket: 'เปิดตั๋ว',

    findFailed: 'เราจับคู่ข้อมูลเหล่านั้นกับออร์เดอร์ไม่ได้',
    refreshFailed: 'รีเฟรชออร์เดอร์ไม่ได้',
    orderNumber: 'หมายเลขออร์เดอร์',
    orderNumberPlaceholder: 'เช่น 1042',
    orderNumberHint: 'แสดงบนหน้าออร์เดอร์และในการยืนยัน',
    username: 'ชื่อผู้ใช้ของบัญชี',
    usernamePlaceholder: 'ชื่อของคุณ',
    last4: 'สี่ตัวอักษรท้ายของรหัสอ้างอิงการชำระเงิน',
    last4Placeholder: 'เช่น 9QX2',
    last4Hint:
      'การเติมเงินที่สำเร็จรายการใดก็ได้ในบัญชี รหัสอ้างอิงมีหน้าตาแบบ PAY-7F3K9QX2 บนหน้า wallet และใบเสร็จ',
    findOrder: 'ค้นหาออร์เดอร์',
    findFoot:
      'ไม่มีรหัสอ้างอิงการชำระเงินในมือ? เปิดตั๋วแทนและแจ้งหมายเลขออร์เดอร์ เจ้าหน้าที่จะตรวจสอบกับคุณ',

    status: {
      PENDING: 'อยู่ในคิว',
      QUEUED: 'อยู่ในคิว',
      SUBMITTING: 'กำลังส่ง',
      PROCESSING: 'กำลังดำเนินการ',
      IN_PROGRESS: 'กำลังจัดส่ง',
      PARTIAL: 'ส่งบางส่วน',
      COMPLETED: 'เสร็จสิ้น',
      CANCELED: 'ยกเลิกแล้ว',
      FAILED: 'ล้มเหลว',
      REFUNDED: 'คืนเงินแล้ว',
    },
    orderKey: 'ออร์เดอร์ #{number}',
    orderMeta: '{platform} · สั่ง {quantity} · {charge} · สั่งเมื่อ {date}',
    done: 'เสร็จ',
    providerNote: 'หมายเหตุจากผู้ให้บริการ: {note}',
    refundedToWallet: 'คืนเงินเข้า wallet',
    checkAfter: 'ตรวจหลัง {n} วัน',
    stillThere: 'ยังอยู่ {held}%',
    due: 'กำหนด {date}',
    refillAt: 'เติมคืน {date}',
    ticketNumber: 'ตั๋ว #{number}',

    escalatedTitle: 'ตั๋ว #{number} อยู่กับเจ้าหน้าที่แล้ว',
    escalatedBody:
      'บันทึกไว้ใต้ออร์เดอร์นี้และใต้บัญชี ลิงก์นี้เปิดตั๋วได้ระหว่างที่คุณเข้าบัญชีไม่ได้ และเป็นสำเนาเดียวของคีย์',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
    copyLink: 'คัดลอกลิงก์',
    openTheTicket: 'เปิดตั๋ว',
    needPersonTitle: 'ยังต้องการเจ้าหน้าที่?',
    needPersonBody: 'ส่งออร์เดอร์นี้ให้ฝ่ายช่วยเหลือ พวกเขาเห็นทุกอย่างข้างบน รวมถึงฝั่งผู้ให้บริการ',
    escalate: 'ส่งต่อให้เจ้าหน้าที่',
    escalateLabel: 'พวกเขาควรรู้อะไรบ้าง?',
    escalatePlaceholder: 'สิ่งที่คุณคาดหวัง สิ่งที่คุณเห็น และอะไรก็ตามที่ตัวเลขข้างบนอธิบายไม่ได้',
    reachYou: 'ช่องทางติดต่อคุณ',
    reachYouEscPlaceholder: 'ไม่บังคับ: ชื่อบัญชีโซเชียล คำตอบจะปรากฏบนตั๋วอยู่ดี',
    escalateFailed: 'เปิดตั๋วไม่ได้',

    emailAttached: 'ผูกอีเมลแล้ว',
    noEmailTitle: 'บัญชีนี้ไม่มีอีเมล',
    noEmailBody: 'ผูกอีเมลแล้วจะรีเซ็ตรหัสผ่านตามปกติได้ ใช้เพื่อการนั้นและใบเสร็จเท่านั้น',
    attachEmail: 'ผูกอีเมล',
    emailLabel: 'อีเมลสำหรับบัญชีนี้',
    emailPlaceholder: "you{'@'}example.com",
    attachSend: 'ผูกและส่งการยืนยัน',
    attachFailed: 'ผูกอีเมลนั้นไม่ได้',
    viewStays: 'หน้านี้เปิดอยู่ 30 นาที',
    refreshOrder: 'รีเฟรชออร์เดอร์',

    yourTickets: 'ตั๋วที่เปิดอยู่ของคุณ',
    ticketOpened: 'เปิดตั๋วแล้ว',
    queuedTitle: 'คุณคือ {number} ในคิว',
    queuedToast: '#{number} อยู่ในคิวแล้ว',
    sentLede:
      'แจ้งทีมงานแล้ว ลิงก์นี้เปิดตั๋วของคุณ แสดงทุกคำตอบ และให้คุณตอบกลับได้ เป็นสำเนาเดียวของคีย์ เก็บไว้ในที่ปลอดภัย',
    sendAnother: 'ส่งอีกฉบับ',
    sentNote: 'เบราว์เซอร์นี้จำคีย์ไว้ด้วย การกลับมาที่หน้าตั๋วจากที่นี่จึงใช้ได้โดยไม่ต้องมีลิงก์',
    yourName: 'ชื่อของคุณ',
    yourNamePlaceholder: 'ให้เราเรียกคุณว่าอะไร?',
    reachYouPlaceholder: 'ไม่บังคับ: ชื่อบัญชีโซเชียล หรือชื่อผู้ใช้ของคุณที่นี่',
    reachYouHint: 'เฉพาะถ้าต้องการ คำตอบจะปรากฏบนตั๋วอยู่ดี',
    about: 'เรื่องนี้เกี่ยวกับ',
    topic: 'หัวข้อ',
    topics: {
      ORDER: 'ออร์เดอร์',
      PAYMENT: 'การชำระเงิน',
      ACCOUNT: 'บัญชีของฉัน',
      REFILL: 'การเติมคืน',
      OTHER: 'เรื่องอื่น',
    },
    subject: 'หัวเรื่อง',
    subjectPlaceholder: 'หนึ่งบรรทัดว่าเรื่องนี้เกี่ยวกับอะไร',
    message: 'ข้อความ',
    messagePlaceholder: 'เกิดอะไรขึ้น คุณคาดหวังอะไร และอะไรที่ช่วยให้เราหาเจอ: หมายเลขออร์เดอร์ ลิงก์ เวลา',
    messageHint: 'หมายเลขออร์เดอร์และลิงก์ช่วยได้ รหัสผ่านไม่ต้อง เราจะไม่ขอ',
    submitGuest: 'เปิดตั๋ว',
    submitUser: 'เปิดตั๋วภายใต้บัญชีของฉัน',
    sendFailed: 'ส่งข้อความของคุณไม่ได้',
    faqFoot: 'อยากหาคำตอบก่อน? {link} ครอบคลุมคำถามที่คนถามจริง รวมถึงคำตอบที่ไม่น่าฟัง',
    faqFootLink: 'คำถามที่พบบ่อย',
  },

  ticket: {
    number: 'ตั๋ว #{number}',
    opening: 'กำลังเปิด…',
    needsKey: 'ตั๋วนี้ต้องใช้คีย์',
    wrongKey: 'คีย์นั้นเปิดตั๋วนี้ไม่ได้',
    needsKeyBody: 'ลิงก์ที่คุณได้รับตอนเปิดตั๋วมีคีย์อยู่ วางคีย์จากลิงก์นั้นด้านล่าง',
    mismatch: 'หมายเลขตั๋วและคีย์ไม่ตรงกัน',
    keyLabel: 'คีย์',
    keyPlaceholder: 'วางคีย์จากลิงก์ของคุณ',
    openTicket: 'เปิดตั๋ว',
    lostKey: 'คีย์หาย? กู้คืนไม่ได้ {link} และระบุ #{number} เพื่อให้เรารวมสองตั๋วเข้าด้วยกัน',
    lostKeyLink: 'เปิดตั๋วใหม่',
    status: {
      OPEN: 'เปิดอยู่',
      PENDING_SUPPORT: 'รอฝ่ายช่วยเหลือ',
      PENDING_CUSTOMER: 'รอคุณ',
      RESOLVED: 'แก้ไขแล้ว',
      CLOSED: 'ปิดแล้ว',
    },
    opened: 'เปิดเมื่อ {date}',
    with: 'กับ {name}',
    staff: '{name} · ฝ่ายช่วยเหลือ',
    you: 'คุณ',
    reply: 'ตอบกลับ',
    replyPlaceholder: 'เพิ่มอะไรก็ได้ที่ช่วยได้ หรือตอบคำถามจากฝ่ายช่วยเหลือ',
    repliesHere: 'คำตอบปรากฏที่นี่ ไม่มีอะไรส่งทางอีเมล',
    sendReply: 'ส่งคำตอบ',
    sendFailed: 'ส่งคำตอบของคุณไม่ได้',
    closed: 'ตั๋วนี้ปิดแล้ว ถ้ายังมีปัญหา {link} และระบุ #{number}',
    closedLink: 'เปิดตั๋วใหม่',
  },

  legal: {
    updated: 'อัปเดต {date}',
    sections: '{n} ส่วน',
    minRead: 'อ่าน {n} นาที',
    contents: 'สารบัญ',
    plainWords: 'พูดง่าย ๆ',
    keepReading: 'อ่านต่อ',
    backToTop: 'กลับขึ้นบน',
  },
}
